"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion_1 = require("./Accordion");
exports.default = Accordion_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Accordion/index.js
// module id = 1736
// module chunks = 8